/* eslint-disable @next/next/no-img-element */
export function Avatar({
  name,
  image,
  size = 40,
  className = '',
}: {
  name: string;
  image?: string | null;
  size?: number;
  className?: string;
}) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join('');
  const style = { width: size, height: size, fontSize: Math.max(11, size * 0.38) };
  if (image) {
    return (
      <img
        src={image}
        alt=""
        width={size}
        height={size}
        style={style}
        className={`shrink-0 rounded-full object-cover ring-2 ring-white ${className}`}
      />
    );
  }
  return (
    <span
      style={style}
      /* No photograph: the circle is the page's colour rather than navy, so a
         household of initials does not read as a different site. `accent-band`
         carries the corrected shade and its ink, because these are letters on
         the accent like any other label. */
      className={`accent-band inline-flex shrink-0 items-center justify-center rounded-full font-bold ring-2 ring-white ${className}`}
      aria-hidden
    >
      {initials || '·'}
    </span>
  );
}
